import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from '../../../plugins/axios';
import { useTranslation } from "react-i18next";
import { selectBedInfoState, wardSuspendState,unitState, deviceModelInfo } from '../../../plugins/recoil';
import { useRecoilState } from 'recoil';
import Toast from '../../../plugins/useToast';
import { useBedData } from '../../../context/BedDataContext';
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg,percentToKpa,mmHgToPercent } from '../../../plugins/common';
import {ReactComponent as IconInit} from '../../../assets/icons/ic-init.svg';
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';

function AlarmSettings({deviceInfo, handleSaveParameter, deviceModelMenus }) { 
    const { t } = useTranslation()             
    const isFirstRender = useRef(true);        
    const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState)
    const [wardSuspend,] = useRecoilState(wardSuspendState)    
    const [originalDeviceAlarms, setOriginalDeviceAlarms] = useState({}); // 원본 알람 설정 살태
    const [changeDeviceAlarms, setChangeDeviceAlarms] = useState({}); // 변경된 알람 설정 상태    
    const [defaultAlarms, setDefaultAlarms] = useState({}); // 기본 알람 설정 상태        
    const [isDisabled, setIsDisabled] = useState(true);
    const [isInitAlarmData, setIsInitAlarmData] = useState(true);
    const [allAlarms, setAllAlarms] = useState(false);
    const [originalAllAlarms, setOriginalAllAlarms] = useState(false);
    const [isResetable, setIsResetable] = useState(false);    
    const [limitRange, setLimitRange] = useState({}) // DropDown 데이터
    const [units,] = useRecoilState(unitState);
    const { getBedData, version } = useBedData()
    const bedData = getBedData()
    const [isModify, setIsModify] = useState();

    //Select를 위한 useState
    const [openDropdown, setOpenDropdown] = useState({ group: null, key: null });
    const dropdownRefs = useRef({});

    const handleAllAlarmsChange = async () => {        
        const updatedAllAlarms = !allAlarms;
        setAllAlarms(updatedAllAlarms); // allAlarms 상태 업데이트
    };
    
    const handleSave = async () => {
        //save 시 Change 된 Alarm 값으로 Save
        try{
            const payload = {                
                measureAlarmValues: changeDeviceAlarms.map(alarm => ({
                    measureParameterId: alarm.measureParameterId,
                    min: alarm.min,
                    max: alarm.max
                })),
                suspended: allAlarms,
            }

            const res = await axios.put(`/device/${selectBedInfo.deviceId}/alarm`, payload);
            if (res.code != '200') throw res;

            setSelectBedInfo(prev => ({
                ...prev,
                suspended: allAlarms
            }))
            handleSaveParameter()
            Toast({ isSuccess: true });
            getDeviceAlarms()
        }
        catch(err){
            console.error(err);
            Toast({ isSuccess: false, msg: err.message });
        }
    }

    //Reset 버튼 클릭 시 Default Alarm 값으로 초기화
    const handleReset = async () => {
        try{            
            //setOriginalDeviceAlarms(Object.fromEntries(defaultAlarms.map(item => [item.parameter, item])))
            setChangeDeviceAlarms(defaultAlarms.map(item => ({ ...item })))

            setAllAlarms(false);            
        }
        catch(err){
            console.error(err);
            Toast({ isSuccess: false, msg: err.message });
        }
    }    

    //최초 alarm 설정 가져오기
    const getDeviceAlarms = async () => {
        try {  
            //Reset 최초 데이터 가져오기
            const defaultAlarmRes = await axios.get(`/measure/parameters/alarm`);
            if (defaultAlarmRes.code != '200') throw Toast({ isSuccess: false, msg : defaultAlarmRes });

            //Limit Range Data 만들기
            const LimitRange = makeAllRangeOptions(defaultAlarmRes.data.parameters);
            setLimitRange(LimitRange); //DropDown Data

            const parameters = defaultAlarmRes.data.parameters;
            setDefaultAlarms(parameters);            

            //Rodney - 실제 Device에서 사용중인 Alarm 설정 가져오기
            const AlarmRes = await axios.get(`/device/${selectBedInfo.deviceId}/alarm`)
            if (AlarmRes.code != '200') throw Toast({ isSuccess: false, msg : AlarmRes });

            //기존에 설정된 알람이 없으면 기본값으로 설정
            //const alarmList = (AlarmRes.data.measureAlarmValues && AlarmRes.data.measureAlarmValues.length > 0) ? AlarmRes.data.measureAlarmValues : parameters; 
            const alarmList = AlarmRes.data.measureAlarmValues; 
            const mergeData = mergeAlarmData(alarmList,parameters); //Parameter ID로 code name과 min/max를 가져올 수 있어서 merge를 진행함.
            
            // 최초 데이터가 없을 경우에만 저장 가능하게.
            if (!AlarmRes.data.measureAlarmValues || AlarmRes.data.measureAlarmValues.length === 0) {
                setIsInitAlarmData(false);
            }else {
                setIsInitAlarmData(true);
            }

            setAllAlarms(AlarmRes.data.suspended);
            setOriginalAllAlarms(AlarmRes.data.suspended); // Alarm 기존에 있는 데이터 체크
            setOriginalDeviceAlarms(Object.fromEntries(mergeData.map(item => [item.parameter, item]))) //parameter를 key로 하는 객체로 변환            
            setChangeDeviceAlarms(mergeData.map(item => ({ ...item })))
        } catch(err){
            console.warn(err)
        }
    }

        //사용자 세팅의 의한 Alarm 단위 변경하는 함수. (단위의 Unit만 필요한 경우도 있어서 2개로 분기 나눠둠.)
    const convertUnit = (parameter,value,type = 'label') => {
        const nibpSeries = ['NIBPSYS', 'NIBPMAP', 'NIBPDIA']
        const ibpSeries = ['IBP1SYS', 'IBP1MEAN', 'IBP1DIA', 'IBP2SYS','IBP2MEAN', 'IBP2DIA','IBP3SYS', 'IBP3MEAN', 'IBP3DIA', 'IBP4SYS', 'IBP4MEAN', 'IBP4DIA']
        const co2Series = ['EtCO2', 'InCO2']
        const tempSeries = ['Temp1', 'Temp2']
        const gasSeries = ['GasCO2Ex','GasCO2In','GasAA1Ex','GasAA1In','GasAA2Ex','GasAA2In','GasO2Ex','GasO2In','GasN2OEx','GasN2OIn']
        const otherSeries = ['HR', 'RR', 'awRR', 'SpO2', 'Arrhythmia', 'IPI']

            //함수를 유동적으로 사용해보고 싶어서 써봄.
        const convertFunctions = {
            mmHgToKPa,
            celsiusToFahrenheit,
            percentTommHg,
            percentToKpa,
            mmHgToPercent
        };

        let unit = undefined;
        let functionName = undefined;

        if (nibpSeries.includes(parameter)) {
            unit = units["NIBP"];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (ibpSeries.includes(parameter)) {
            const prefix = parameter.match(/^IBP[1-4]/)?.[0];  // "IBP1", "IBP2" 등 추출
            unit = units[prefix];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (co2Series.includes(parameter)) {
            unit = units[parameter];            
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === '%'){
                functionName = 'mmHgToPercent'; // mmHg를 %로 변환하는 함수
            }
        } else if (tempSeries.includes(parameter)) {
            unit = units[parameter];
            if(unit === '°F') {
                functionName = 'celsiusToFahrenheit'; // mmHg를 kPa로 변환하는 함수
            }
        } 
        else if (gasSeries.includes(parameter)) {
            unit = units["GAS"];            
            if(unit === 'mmHg') {
                functionName = 'percentTommHg'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === 'kPa'){
                functionName = 'percentToKpa';
            }            
        } else if(otherSeries.includes(parameter)) {
            unit = units[parameter];
        }

        if(type == 'unit'){
            return unit;
        }else if(type == 'label'){
            let label = value;
            if (functionName && typeof convertFunctions[functionName] === 'function') {
                label = convertFunctions[functionName](value);
            }
            return label;
        }
    }

    // useEffect(() => {
    //   console.log('originalDeviceAlarms : ', originalDeviceAlarms);
    //   console.log('changeDeviceAlarms : ', changeDeviceAlarms);
    // }, [originalDeviceAlarms, changeDeviceAlarms]);    
    
    // Limit Range Data 만들기
    // const makeAllRangeOptions = (paramList) => {
    //     return paramList.reduce((acc, param) => {
    //         const { parameter, minLimit, maxLimit, step } = param;
    //         // min이 null, undefined, '' 등 falsy면 0으로 처리
    //         const safeMin = (minLimit ?? 0);
    //         const safeMax = (maxLimit ?? 0);
    //         const safeStep = (step ?? 1);
    //         const values = [];
    //         for (let v = safeMin; v <= safeMax; v = +(v + safeStep).toFixed(10)) {
    //             values.push(Number(v));
    //         }
    //         acc[parameter] = { value: values };
    //         return acc;
    //     }, {});
    // }

    const makeAllRangeOptions = (paramList) => {
        return paramList.reduce((acc, param) => {
            const { parameter, minLimit, maxLimit, step } = param;
            // min이 null, undefined, '' 등 falsy면 0으로 처리
            const safeMin = (minLimit ?? 0);
            const safeMax = (maxLimit ?? 0);
            const safeStep = (step ?? 1);
            const limits = [];                                   

            //option 값 생성. value label
            for (let v = safeMin; v <= safeMax; v = +(v + safeStep).toFixed(10)) {
                const value = Number(v);
                const label = convertUnit(parameter,value,'label');
                limits.push({ value, label });
            }
            
            acc[parameter] = limits;
            return acc;
        }, {});
    }

    //최초 데이터 id 기준 code Data 가져오기
    const mergeAlarmData = (alarmList, parameters) => {
        // parameters를 객체로 변환 (빠른 lookup을 위해)
        const paramMap = {};
        parameters.forEach(param => {
            paramMap[param.measureParameterId] = param;
        });

        // alarmList와 parameters를 merge (필요한 필드만 포함)
        return alarmList.map(alarm => {
            const param = paramMap[alarm.measureParameterId];
            if (param) {
                return {
                    ...alarm,
                    parameter: param.parameter,
                    measurementUnit: param.measurementUnit,
                    minLimit: param.minLimit,
                    maxLimit: param.maxLimit,
                };
            }
            return alarm;
        });
    };        

    const columnCounts = [9, 10, 10, 6];
    const columns = useMemo(() => {
        if (!changeDeviceAlarms || !Array.isArray(changeDeviceAlarms)) return [];
        let startIndex = 0;
        return columnCounts.map(count => {
            const endIndex = startIndex + count;
            const slice = changeDeviceAlarms.slice(startIndex, endIndex);
            startIndex = endIndex;            
            return slice;
        });        
    }, [changeDeviceAlarms]);    

    // 최초 Render 시 해당 Device 알람 설정 가져오기
    useEffect(() => {
        getDeviceAlarms()        
        const isModify = deviceModelMenus.find(item => item.model === deviceInfo.deviceModel)?.alarmLimitModify;
        setIsModify(isModify); 
    }, [deviceInfo])

    // 변경된 알람 설정이 있는지 체크하여 Save 버튼 활성화/비활성화
    useEffect(() => {
        //최초 Render 시에는 비활성화
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        //데이터가 이상한 경우에는 return
        if (!Array.isArray(changeDeviceAlarms) || !originalDeviceAlarms) {
            setIsDisabled(true);
            return;
        }

        // Save 가능 여부 체크
        const isAlarmValuesChanged = changeDeviceAlarms.some(alarm => {
            // paramterId(Alarm Code)로 원본 찾기
            const original = Object.values(originalDeviceAlarms).find(
                o => o.measureParameterId === alarm.measureParameterId
            );
            if (!original) return false;
            return alarm.min !== original.min || alarm.max !== original.max;
        });

        const isAllAlarmsChanged = allAlarms !== originalAllAlarms;
        const isChanged = isAlarmValuesChanged || isAllAlarmsChanged;

        setIsDisabled(!isChanged);        

        // Reset 가능 여부 체크
        const isResetChanged = changeDeviceAlarms.some(alarm => {
            const def = defaultAlarms.find(d => d.measureParameterId === alarm.measureParameterId);
            if (!def) return false;
            return alarm.min !== def.min || alarm.max !== def.max;
        });        
        
        setIsResetable(isResetChanged);
    }, [changeDeviceAlarms, originalDeviceAlarms,allAlarms]);

    useEffect(() => {
        if (wardSuspend === '1') {
            setAllAlarms(true);
        } else if (wardSuspend === '0') {
            if (selectBedInfo) {
                setAllAlarms(selectBedInfo.suspended);
            }
        }
    }, [wardSuspend]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (openDropdown.key && dropdownRefs.current[openDropdown.key]) {
                const ref = dropdownRefs.current[openDropdown.key];
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpenDropdown({ group: null, key: null });
                }
            }
        }

        // 드롭다운이 열릴 때 선택된 옵션으로 스크롤 이동
        if (openDropdown.key && dropdownRefs.current[openDropdown.key]) {
            const ref = dropdownRefs.current[openDropdown.key];
            if (ref.current) {
                const selected = ref.current.querySelector('.selected-option');
                if (selected) {
                    selected.scrollIntoView({ block: 'nearest' });

                    // 추가 스크롤
                    // const parent = selected.parentElement;
                    // if (parent && typeof parent.scrollTop === 'number') {
                    //     parent.scrollTop = parent.scrollTop + 150; //추가 스크롤 만큼
                    // }
                }
            }
        }

        if (openDropdown.key) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdown]);

    //min & max Type | Row 
    function LimitDropdown(value,oppoValue,type, paramKey,globalIdx) {
        const dropdownKey = type + paramKey;
        if (!dropdownRefs.current[dropdownKey]) {
            dropdownRefs.current[dropdownKey] = React.createRef();
        }        
        const thisDropdownRef = dropdownRefs.current[dropdownKey];
        const openUp = [6,7,8,16,17,18,26,27,28].includes(globalIdx); // 드롭다운이 열릴 때 위로 열리는지 아래로 열리는지 결정 (인덱스에 따라 조정 필요) - 어짜피 여기만 써서 그냥 하드코딩

        return (            
            <div className="relative w-[88px] h-[30px] " ref={thisDropdownRef}>
                <div className={`${!isModify ? 'cursor-default' : 'cursor-pointer'} text-[#DEDEDE] px-[4px] py-[7px] rounded-[6px] flex items-center justify-evenly group`}
                    onClick={() => {
                        if(isModify){
                            setOpenDropdown(prev =>
                                prev.key === type + paramKey
                                    ? { group: null, key: null } // 이미 열려있으면 닫기
                                    : { group: null, key: type + paramKey } // 아니면 열기
                            );
                        }
                    }}
                >
                    <div className={`${!isModify ? 'opacity-10' : ''} w-full text-right`}>{convertUnit(paramKey,value)}</div>                    
                    {/* <
                        className={`
                            ml-[6px] pointer-events-none                            
                            ${openDropdown.key === type + paramKey
                                ? 'block'
                                : 'hidden group-hover:block'
                            }
                            block
                        `}
                    > */}
                    <div
                        className={`
                            ml-[6px] pointer-events-none                            
                            ${openDropdown.key === type + paramKey
                                ? 'opacity-100'
                                : 'opacity-0 group-hover:opacity-100'
                            }
                            block
                        `}
                    >
                        <span className={`${isModify ? 'visible' : 'invisible'}`}>
                            {openDropdown.key === type+paramKey ? <IconArrowUp /> : <IconArrowDown />} 
                        </span>
                    </div>                    
                </div>
                {openDropdown.key === type+paramKey && (
                    <div className={`gender-dropdow absolute scrollbar scrollbar-10px max-h-[150px] overflow-y-auto bg-[#1F1F1F] w-full py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20                    
                        ${openUp ? 'bottom-[35px]' : 'top-[35px]'}
                    `}>                        
                        {limitRange[paramKey] && limitRange[paramKey]
                            .filter(limit => {
                                if (type === 'max') {
                                    if(['Arrhythmia', 'GasO2Ex', 'GasO2In'].includes(paramKey)){
                                        return limit.value >= oppoValue; // oppoValue(=min)보다 큰 값만
                                    }else{
                                        return limit.value > oppoValue; // oppoValue(=min)보다 큰 값만
                                    }
                                } else if (type === 'min') {
                                    if(['IPI'].includes(paramKey)){
                                        return true; // oppoValue(=max)보다 큰 값만
                                    }else{
                                        return limit.value < oppoValue; // oppoValue(=max)보다 큰 값만
                                    }
                                }
                                return true;
                            })                        
                            .map((limit, index) => {
                                return (
                                    <div                                                             
                                        key={`${paramKey}-${index}`}
                                        className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                                    ${changeDeviceAlarms[globalIdx][type] === limit.value ? "text-[#3182F7] selected-option" : "text-white"}`}
                                        onClick={() => {  
                                            setChangeDeviceAlarms(prev => {
                                                const updated = [...prev];
                                                updated[globalIdx][type] = limit.value;

                                                // 연동 파라미터 동기화 처리
                                                const syncPairs = [
                                                    ['RESP', 'awRR'],
                                                ];

                                                const curParam = updated[globalIdx].parameter;
                                                const pair = syncPairs.find(([a, b]) => curParam === a || curParam === b);

                                                if (pair) {
                                                    const [a, b] = pair;                                                    
                                                    const target = curParam === a ? b : a;
                                                    const targetIdx = updated.findIndex(alarm => alarm.parameter === target);

                                                    if (targetIdx !== -1) {
                                                        updated[targetIdx][type] = limit.value;
                                                    }
                                                }

                                                return updated;
                                            });
                                            setOpenDropdown({ group: null, key: null });
                                        }}>
                                        {limit.label}
                                        {changeDeviceAlarms[globalIdx][type] === limit.value && (
                                            <IconCheck className="w-4 h-4 ml-2" />
                                        )}
                                    </div>
                                )
                            })
                        }                       
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="relative w-full h-full">
            <div className="overflow-y-auto scrollbar" style={{ height: 'calc(100%)' }}>
                <div className="relative flex w-full p-[19px] items-start">
                    <div className="flex items-center gap-[8px] mr-[20px]" style={{ opacity: (wardSuspend === '1' || bedData[selectBedInfo.serial]?.silenceData?.alarmPause === '1' || bedData[selectBedInfo.serial]?.silenceData?.audioPause === '1') ? 0.5 : 1 }}>
                        <label className={`${!isModify ? 'opacity-50' : ''} text-[#fff] text-[18px]`}>{t('bedSetting.alarmOff')}</label>
                        <input
                            type="checkbox"
                            checked={
                                (wardSuspend === '1' || bedData[selectBedInfo.serial]?.silenceData?.alarmPause === '1' || bedData[selectBedInfo.serial]?.silenceData?.audioPause === '1') ? true : allAlarms }
                            onChange={handleAllAlarmsChange}
                            disabled={!isModify || (wardSuspend === '1' || bedData[selectBedInfo.serial]?.silenceData?.alarmPause === '1' || bedData[selectBedInfo.serial]?.silenceData?.audioPause === '1')}
                        />
                    </div>

                    <div className="grid grid-cols-4 gap-[16px] bg-[#2F2F2F] p-[16px] rounded-[8px]">
                        {
                            columns.map((alarmColumn, columnIndex) => {
                                const startIndex = columnCounts.slice(0, columnIndex).reduce((a, b) => a + b, 0);
                                return (
                                    <div key={`column-${columnIndex}`}>
                                        <table className="w-full text-[#fff]">
                                            <thead>
                                                <tr>
                                                    <th className="border-y border-[#444] bg-[#262626] !h-[30px] w-[190px] font-light">{t('bedSetting.vitalSigns')}</th>
                                                    <th className="border border-[#444] bg-[#262626] !h-[30px] w-[88px] font-light">{t('bedSetting.max')}</th>
                                                    <th className="border-y border-[#444] bg-[#262626] !h-[30px] w-[88px] font-light">{t('bedSetting.min')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {                                                    
                                                    alarmColumn.map((alarm, idx) => {
                                                        const globalIdx = startIndex + idx; // 전체 배열에서의 인덱스
                                                        const unit = convertUnit(alarm.parameter, '_', 'unit');
                                                        return (
                                                            <tr key={`alarm-${idx}`} className={idx % 2 === 0 ? "bg-[#2F2F2F]" : "bg-[#343434]"}>
                                                                <td className="flex items-center font-light !h-[30px]">
                                                                    {/* <div className="w-[auto]">{alarm.parameter || ''} {(alarm.measurementUnit || '').trim() ? `(${alarm.measurementUnit})` : ''}</div> */}
                                                                    <div className='w-[auto]'>
                                                                        {alarm.parameter}     
                                                                        {
                                                                            (unit || alarm.measurementUnit) ? (
                                                                                <>
                                                                                    {unit ? ` (${unit})` : ''}
                                                                                </>
                                                                            ) : null
                                                                        }           
                                                                    </div>
                                                                </td>                                                                
                                                                <td className={`text-right ${alarm.max != originalDeviceAlarms[alarm.parameter]?.max ? 'bg-[#2F2F2F] bg-[linear-gradient(0deg,rgba(49,130,247,0.3)_0%,rgba(49,130,247,0.3)_100%)]' : 'border-l border-[#444]'} p-0 font-light !h-[30px]`}>
                                                                    {
                                                                        !["IPI"].includes(alarm.parameter) && (
                                                                            LimitDropdown(alarm.max,alarm.min,'max', alarm.parameter,globalIdx)
                                                                        )
                                                                    }
                                                                </td>
                                                                <td className={`p-0 box-content ${alarm.min != originalDeviceAlarms[alarm.parameter]?.min ? (`${idx % 2 === 0 ? 'bg-[#2F2F2F]' : 'bg-[#343434]'} bg-[linear-gradient(0deg,rgba(49,130,247,0.3)_0%,rgba(49,130,247,0.3)_100%)]`) : 'border-l border-[#444]'} font-light text-right !h-[30px]`}>
                                                                    <span className="hidden">{alarm.min}</span>
                                                                    <span className="hidden">{originalDeviceAlarms[alarm.parameter]?.min}</span>
                                                                    {
                                                                        !["Arrhythmia", "GasO2Ex", "GasO2In"].includes(alarm.parameter) && (
                                                                            LimitDropdown(alarm.min,alarm.max,'min', alarm.parameter,globalIdx)
                                                                        )
                                                                    }
                                                                </td>
                                                            </tr>   
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            )
                        }
                    </div>
                </div>
            </div>  
            {
                isModify && (
                    <button className={`w-[88px] h-[28px] pr-5 absolute top-[-35px] right-[120px] rounded-[6px] font-light
                        ${!isResetable? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                        : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                        active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}            
                    onClick={() => {handleReset()}}
                    disabled={!isResetable}
                    >
                        {t('bedSetting.reset')}
                        <span className="absolute right-3 top-[4px]" style={{ opacity: isResetable ? 1 : 0.3 }}>
                            <IconInit />
                        </span>
                    </button>
                )
            }
            <button className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] font-light
                    ${(isInitAlarmData && isDisabled) ? 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                    : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                disabled={(isInitAlarmData && isDisabled)}
                onClick={handleSave}
            >
                {isDisabled ? t('bedSetting.saved') : t('bedSetting.save')}
            </button>
        </div>
    );
}

export default AlarmSettings;
